import React, { useState } from 'react';
import '../styles/Industrial.css';

// Explicitly import Greases PDFs (unchanged from previous)
import Greases1 from '../greases/greases(1).pdf';
import Greases2 from '../greases/greases(2).pdf';
import Greases3 from '../greases/greases(3).pdf';
import Greases4 from '../greases/greases(4).pdf';
import Greases5 from '../greases/greases(5).pdf';
import Greases6 from '../greases/greases(6).pdf';
import Greases7 from '../greases/greases(7).pdf';
import Greases8 from '../greases/greases(8).pdf';
import Greases9 from '../greases/greases(9).pdf';
import Greases10 from '../greases/greases(10).pdf';
import Greases11 from '../greases/greases(11).pdf';
import Greases12 from '../greases/greases(12).pdf';
import Greases13 from '../greases/greases(13).pdf';
import Greases14 from '../greases/greases(14).pdf';
import Greases15 from '../greases/greases(15).pdf';
import Greases16 from '../greases/greases(16).pdf';
import Greases17 from '../greases/greases(17).pdf';
import Greases18 from '../greases/greases(18).pdf';
import Greases19 from '../greases/greases(19).pdf';
import Greases20 from '../greases/greases(20).pdf';
import Greases21 from '../greases/greases(21).pdf';
import Greases22 from '../greases/greases(22).pdf';
import Greases23 from '../greases/greases(23).pdf';
import Greases24 from '../greases/greases(24).pdf';
import Greases25 from '../greases/greases(25).pdf';
import Greases26 from '../greases/greases(26).pdf';
import Greases27 from '../greases/greases(27).pdf';
import Greases28 from '../greases/greases(28).pdf';
import Greases29 from '../greases/greases(29).pdf';
import Greases30 from '../greases/greases(30).pdf';
import Greases31 from '../greases/greases(31).pdf';
import Greases32 from '../greases/greases(32).pdf';
import Greases33 from '../greases/greases(33).pdf';
import Greases34 from '../greases/greases(34).pdf';
import Greases35 from '../greases/greases(35).pdf';
import Greases36 from '../greases/greases(36).pdf';
import Greases37 from '../greases/greases(37).pdf';
import Greases38 from '../greases/greases(38).pdf';
import Greases39 from '../greases/greases(39).pdf';
import Greases40 from '../greases/greases(40).pdf';
import Greases41 from '../greases/greases(41).pdf';
import Greases42 from '../greases/greases(42).pdf';
import Greases43 from '../greases/greases(43).pdf';
import Greases44 from '../greases/greases(44).pdf';
import Greases45 from '../greases/greases(45).pdf';
import Greases46 from '../greases/greases(46).pdf';
import Greases47 from '../greases/greases(47).pdf';
import Greases48 from '../greases/greases(48).pdf';
import Greases49 from '../greases/greases(49).pdf';
import Greases50 from '../greases/greases(50).pdf';
import Greases51 from '../greases/greases(51).pdf';
import Greases52 from '../greases/greases(52).pdf';
import Greases53 from '../greases/greases(53).pdf';
import Greases54 from '../greases/greases(54).pdf';
import Greases55 from '../greases/greases(55).pdf';
import Greases56 from '../greases/greases(56).pdf';
import Greases57 from '../greases/greases(57).pdf';
import Greases58 from '../greases/greases(58).pdf';
import Greases59 from '../greases/greases(59).pdf';
import Greases60 from '../greases/greases(60).pdf';
import Greases61 from '../greases/greases(61).pdf';
import Greases62 from '../greases/greases(62).pdf';
import Greases63 from '../greases/greases(63).pdf';
import Greases64 from '../greases/greases(64).pdf';
import Greases65 from '../greases/greases(65).pdf';
import Greases66 from '../greases/greases(66).pdf';
import Greases67 from '../greases/greases(67).pdf';
import Greases68 from '../greases/greases(68).pdf';
import Greases69 from '../greases/greases(69).pdf';
import Greases70 from '../greases/greases(70).pdf';
import Greases71 from '../greases/greases(71).pdf';
import Greases72 from '../greases/greases(72).pdf';
import Greases73 from '../greases/greases(73).pdf';
import Greases74 from '../greases/greases(74).pdf';
import Greases75 from '../greases/greases(75).pdf';
import Greases76 from '../greases/greases(76).pdf';

// Explicitly import Compressor Oil PDFs from src/greases (adjust path if in a different folder)
import CompressorOil1 from '../compressoroil/compressoroil (1).pdf';
import CompressorOil2 from '../compressoroil/compressoroil (2).pdf';
import CompressorOil3 from '../compressoroil/compressoroil (3).pdf';
import CompressorOil4 from '../compressoroil/compressoroil (4).pdf';
import CompressorOil5 from '../compressoroil/compressoroil (5).pdf';


import HydraulicOil1 from '../hydraulicoil/hydraulicoil (1).pdf';
import HydraulicOil2 from '../hydraulicoil/hydraulicoil (2).pdf';
import HydraulicOil3 from '../hydraulicoil/hydraulicoil (3).pdf';
import HydraulicOil4 from '../hydraulicoil/hydraulicoil (4).pdf';
import HydraulicOil5 from '../hydraulicoil/hydraulicoil (5).pdf';
import HydraulicOil6 from '../hydraulicoil/hydraulicoil (6).pdf';

import MetalWorkingFluid1 from '../metalworkingfluid/metalworkingfluid (1).pdf';
import MetalWorkingFluid2 from '../metalworkingfluid/metalworkingfluid (2).pdf';
import MetalWorkingFluid3 from '../metalworkingfluid/metalworkingfluid (3).pdf';
import MetalWorkingFluid4 from '../metalworkingfluid/metalworkingfluid (4).pdf';
import MetalWorkingFluid5 from '../metalworkingfluid/metalworkingfluid (5).pdf';
import MetalWorkingFluid6 from '../metalworkingfluid/metalworkingfluid (6).pdf';
import MetalWorkingFluid7 from '../metalworkingfluid/metalworkingfluid (7).pdf';
import MetalWorkingFluid8 from '../metalworkingfluid/metalworkingfluid (8).pdf';
import MetalWorkingFluid9 from '../metalworkingfluid/metalworkingfluid (9).pdf';
import MetalWorkingFluid10 from '../metalworkingfluid/metalworkingfluid (10).pdf';
import MetalWorkingFluid11 from '../metalworkingfluid/metalworkingfluid (11).pdf';
import MetalWorkingFluid12 from '../metalworkingfluid/metalworkingfluid (12).pdf';
import MetalWorkingFluid13 from '../metalworkingfluid/metalworkingfluid (13).pdf';
import MetalWorkingFluid14 from '../metalworkingfluid/metalworkingfluid (14).pdf';
import MetalWorkingFluid15 from '../metalworkingfluid/metalworkingfluid (15).pdf';
import MetalWorkingFluid16 from '../metalworkingfluid/metalworkingfluid (16).pdf';

import MouldOil1 from '../mouldoil/mouldoil (1).pdf';
import MouldOil2 from '../mouldoil/mouldoil (2).pdf';
import MouldOil3 from '../mouldoil/mouldoil (3).pdf';
import MouldOil4 from '../mouldoil/mouldoil (4).pdf';
import MouldOil5 from '../mouldoil/mouldoil (5).pdf';
import MouldOil6 from '../mouldoil/mouldoil (6).pdf';
import MouldOil7 from '../mouldoil/mouldoil (7).pdf';

import OtherSpecialities1 from '../otherspecialities/otherspecialities (1).pdf';
import OtherSpecialities2 from '../otherspecialities/otherspecialities (2).pdf';
import OtherSpecialities3 from '../otherspecialities/otherspecialities (3).pdf';
import OtherSpecialities4 from '../otherspecialities/otherspecialities (4).pdf';
import OtherSpecialities5 from '../otherspecialities/otherspecialities (5).pdf';
import OtherSpecialities6 from '../otherspecialities/otherspecialities (6).pdf';
import OtherSpecialities7 from '../otherspecialities/otherspecialities (7).pdf';
import OtherSpecialities8 from '../otherspecialities/otherspecialities (8).pdf';
import OtherSpecialities9 from '../otherspecialities/otherspecialities (9).pdf';
import OtherSpecialities10 from '../otherspecialities/otherspecialities (10).pdf';

import RollingOil1 from '../rollingoil/rollingoil (1).pdf';
import RollingOil2 from '../rollingoil/rollingoil (2).pdf';
import RollingOil3 from '../rollingoil/rollingoil (3).pdf';
import RollingOil4 from '../rollingoil/rollingoil (4).pdf';
import RollingOil5 from '../rollingoil/rollingoil (5).pdf';
import RollingOil6 from '../rollingoil/rollingoil (6).pdf';
import RollingOil7 from '../rollingoil/rollingoil (7).pdf';
import RollingOil8 from '../rollingoil/rollingoil (8).pdf';
import RollingOil9 from '../rollingoil/rollingoil (9).pdf';
import RollingOil10 from '../rollingoil/rollingoil (10).pdf';
import RollingOil11 from '../rollingoil/rollingoil (11).pdf';
import RollingOil12 from '../rollingoil/rollingoil (12).pdf';
import RollingOil13 from '../rollingoil/rollingoil (13).pdf';
import RollingOil14 from '../rollingoil/rollingoil (14).pdf';

import QuenchOil from '../quenchoil/quenchoil.pdf';
import RustPreservatives1 from '../rustpreservatives/rustpreservatives (1).pdf';
import RustPreservatives2 from '../rustpreservatives/rustpreservatives (2).pdf';
import RustPreservatives3 from '../rustpreservatives/rustpreservatives (3).pdf';
import RustPreservatives4 from '../rustpreservatives/rustpreservatives (4).pdf';
import RustPreservatives5 from '../rustpreservatives/rustpreservatives (5).pdf';
import RustPreservatives6 from '../rustpreservatives/rustpreservatives (6).pdf';
import RustPreservatives7 from '../rustpreservatives/rustpreservatives (7).pdf';
import RustPreservatives8 from '../rustpreservatives/rustpreservatives (8).pdf';
import RustPreservatives9 from '../rustpreservatives/rustpreservatives (9).pdf';
import RustPreservatives10 from '../rustpreservatives/rustpreservatives (10).pdf';
import RustPreservatives11 from '../rustpreservatives/rustpreservatives (11).pdf';
import RustPreservatives12 from '../rustpreservatives/rustpreservatives (12).pdf';
// Array of Greases PDFs (unchanged from previous)
import TurbineOil1 from '../turbineoil/turbineoil (1).pdf';
import TurbineOil2 from '../turbineoil/turbineoil (2).pdf';
import TurbineOil3 from '../turbineoil/turbineoil (3).pdf';

import TransmissionOil1 from '../transmissionoil/transmissionoil (1).pdf';
import TransmissionOil2 from '../transmissionoil/transmissionoil (2).pdf';
import TransmissionOil3 from '../transmissionoil/transmissionoil (3).pdf';

import TransformerOil from '../transformeroil/transformeroil.pdf';

import ThreadCompounds1 from '../threadcompounds/threadcompounds (1).pdf';
import ThreadCompounds2 from '../threadcompounds/threadcompounds (2).pdf';
import ThreadCompounds3 from '../threadcompounds/threadcompounds (3).pdf';
import ThreadCompounds4 from '../threadcompounds/threadcompounds (4).pdf';
import ThreadCompounds5 from '../threadcompounds/threadcompounds (5).pdf';
import MarineEngineOil1 from '../marineengineoil/marineengineoil (1).pdf';
import MarineEngineOil2 from '../marineengineoil/marineengineoil (2).pdf';
import CylinderOil from '../cylinderoil/cylinderoil.pdf';

import SpindleOil from '../spindleoil/spindleoil.pdf';
const greasesPDFs = [
  { name: "Balmerol Biogrease EP 2.pdf", file: Greases1 },
  { name: "Balmerol Synlube SC.pdf", file: Greases2 },
  { name: "Slusol Synlube SC.pdf", file: Greases3 },
  { name: "Maximile LCG3 Grease.pdf", file: Greases4 },
  { name: "Balmerol Yellow Cup - Paint Bush Grease.pdf", file: Greases5 },
  { name: "Balmerol Thermotec PU 2.pdf", file: Greases6 },
  { name: "Balmerol Synthplex 2.pdf", file: Greases7 },
  { name: "Balmerol Supertec PD.pdf", file: Greases8 },
  { name: "Balmerol Spraylube RN.pdf", file: Greases9 },
  { name: "Balmerol Spraylube PM.pdf", file: Greases10 },
  { name: "Balmerol Spraylube OGL 10.pdf", file: Greases11 },
  { name: "Balmerol Spraylube OGL 10 - 2500.pdf", file: Greases12 },
  { name: "Balmerol Spraylube OGL 10 - 1000.pdf", file: Greases13 },
  { name: "Balmerol SML ISUZU Genuine Wheel Bearing Grease.pdf", file: Greases14 },
  { name: "Balmerol Slipcoat.pdf", file: Greases15 },
  { name: "Balmerol Slipcoat R.pdf", file: Greases16 },
  { name: "Balmerol Shackle Grease.pdf", file: Greases17 },
  { name: "Balmerol Sealguard HT N.pdf", file: Greases18 },
  { name: "Balmerol SC HT Grease.pdf", file: Greases19 },
  { name: "Balmerol SC HT Grease (BO).pdf", file: Greases20 },
  { name: "Balmerol SC HT (SPL).pdf", file: Greases21 },
  { name: "Balmerol Ropelube 1000_PDS.pdf", file: Greases22 },
  { name: "Balmerol Rollmach HV 2.pdf", file: Greases23 },
  { name: "Balmerol Rollmach EP (SPL).pdf", file: Greases24 },
  { name: "Balmerol Pyrolube 440.pdf", file: Greases25 },
  { name: "Balmerol PFE 227.pdf", file: Greases26 },
  { name: "Balmerol Omnicom 3M.pdf", file: Greases27 },
  { name: "Balmerol Olitec LL EP Series.pdf", file: Greases28 },
  { name: "Balmerol OGL 4000.pdf", file: Greases29 },
  { name: "Balmerol OGL 500.pdf", file: Greases30 },
  { name: "Balmerol Multipurpose Grease.pdf", file: Greases31 },
  { name: "Balmerol Multigrease RSB 3.pdf", file: Greases32 },
  { name: "Balmerol Multigrease LL RT.pdf", file: Greases33 },
  { name: "Balmerol Maxitrac Grease.pdf", file: Greases34 },
  { name: "Balmerol Maxilife Grease.pdf", file: Greases35 },
  { name: "Balmerol Lubsil Grease.pdf", file: Greases36 },
  { name: "Balmerol Liprex NL.pdf", file: Greases37 },
  { name: "Balmerol Liprex EP Series.pdf", file: Greases38 },
  { name: "Balmerol Lipopol HWR 105_PDS.pdf", file: Greases39 },
  { name: "Balmerol Liplex T2.pdf", file: Greases40 },
  { name: "Balmerol Liplex HDX 460.pdf", file: Greases41 },
  { name: "Balmerol Liplex HD WR 2.pdf", file: Greases42 },
  { name: "Balmerol Liplex HD 4603.pdf", file: Greases43 },
  { name: "Balmerol Liplex HD 460.pdf", file: Greases44 },
  { name: "Balmerol Liplex EM Series.pdf", file: Greases45 },
  { name: "Balmerol Likop 1650.pdf", file: Greases46 },
  { name: "Balmerol Likop 1650 (SPL).pdf", file: Greases47 },
  { name: "Balmerol Licom Grease Series.pdf", file: Greases48 },
  { name: "Balmerol Licom 3M Grease.pdf", file: Greases49 },
  { name: "Balmerol Licom 2 Super.pdf", file: Greases50 },
  { name: "Balmerol Licom 2 Premium.pdf", file: Greases51 },
  { name: "Balmerol L C Compound or Lanconite Grease.pdf", file: Greases52 },
  { name: "Balmerol Hytec EP 2.pdf", file: Greases53 },
  { name: "Balmerol HTM 2.pdf", file: Greases54 },
  { name: "Balmerol Grease SMB 2.pdf", file: Greases55 },
  { name: "Balmerol Grease Seal Guard HT.pdf", file: Greases56 },
  { name: "Balmerol Grease Moly Series.pdf", file: Greases57 },
  { name: "Balmerol Grease HTB.pdf", file: Greases58 },
  { name: "Balmerol Grease DCCS 40.pdf", file: Greases59 },
  { name: "Balmerol Grease CG1.pdf", file: Greases60 },
  { name: "Balmerol Grease Autoplex.pdf", file: Greases61 },
  { name: "Balmerol Graphite Grease.pdf", file: Greases62 },
  { name: "Balmerol Graphite Grease 0.pdf", file: Greases63 },
  { name: "Balmerol FW-HT Super Grease.pdf", file: Greases64 },
  { name: "Balmerol DRI-LUBE '0' (M).pdf", file: Greases65 },
  { name: "Balmerol CVJ Grease.pdf", file: Greases66 },
  { name: "Balmerol Crusher Grease.pdf", file: Greases67 },
  { name: "Balmerol Chassis L Grease.pdf", file: Greases68 },
  { name: "Balmerol CCSM HT.pdf", file: Greases69 },
  { name: "Balmerol Calplex Grease.pdf", file: Greases70 },
  { name: "Balmerol Blutak 40.pdf", file: Greases71 },
  { name: "Balmerol Blucoat.pdf", file: Greases72 },
  { name: "Balmerol Blucoat SM.pdf", file: Greases73 },
  { name: "Balmerol Blucoat SM 85 (NB).pdf", file: Greases74 },
  { name: "Balmerol Basecoat.pdf", file: Greases75 },
  { name: "Balmerol Anticor SC.pdf", file: Greases76 },
  
];
// Array of Compressor Oil PDFs
const compressorOilPDFs = [
  { name: "Balmerol Synthpress Series.pdf", file: CompressorOil1 },
  { name: "Balmerol Protopress T 68.pdf", file: CompressorOil2 },
  { name: "Balmerol Protopress SS Series.pdf", file: CompressorOil3 },
  { name: "Balmerol Protopress Series.pdf", file: CompressorOil4 },
  { name: "Balmerol Protopress R 68.pdf", file: CompressorOil5 }
];
const hydraulicOilPDFs = [
  { name: "Balmerol Protomac Hydralube Series.pdf", file: HydraulicOil1 },
  { name: "Balmerol Protomac HLP Series.pdf", file: HydraulicOil2 },
  { name: "Balmerol Protomac H SPL_Series.pdf", file: HydraulicOil3 },
  { name: "Balmerol Protomac H SPL (ZF) Series.pdf", file: HydraulicOil4 },
  { name: "Balmerol Protomac H Series.pdf", file: HydraulicOil5 },
  { name: "Balmerol Aqua Hydol 68.pdf", file: HydraulicOil6 }
];

const metalWorkingFluidPDFs = [
  { name: "Balmerol Protocut 332.pdf", file: MetalWorkingFluid1 },
  { name: "Balmerol Synthcut GR.pdf", file: MetalWorkingFluid2 },
  { name: "Balmerol Protoform BD 220.pdf", file: MetalWorkingFluid3 },
  { name: "Balmerol Protoform BD 120.pdf", file: MetalWorkingFluid4 },
  { name: "Balmerol Protoform ALWD 150.pdf", file: MetalWorkingFluid5 },
  { name: "Balmerol Protoform 480.pdf", file: MetalWorkingFluid6 },
  { name: "Balmerol Protocut GG 10R.pdf", file: MetalWorkingFluid7 },
  { name: "Balmerol Protocut 332 NS.pdf", file: MetalWorkingFluid8 },
  { name: "Balmerol Balmocut SS 40.pdf", file: MetalWorkingFluid9 },
  { name: "Balmerol Protohon 15 C.pdf", file: MetalWorkingFluid10 },
  { name: "Balmerol Protohon 14.pdf", file: MetalWorkingFluid11 },
  { name: "Balmerol Protocut 332.pdf", file: MetalWorkingFluid12 },
  { name: "Balmerol Protocut 312.pdf", file: MetalWorkingFluid13 },
  { name: "Balmerol Protocut 132.pdf", file: MetalWorkingFluid14 },
  { name: "Balmerol Balmocut SS Premium.pdf", file: MetalWorkingFluid15 },
  { name: "Balmerol Balmocut CL.pdf", file: MetalWorkingFluid16 }
];

const mouldOilPDFs = [
  { name: "Balmerol Synth Moldol 80.pdf", file: MouldOil1 },
  { name: "Balmerol Synth Moldol 46.pdf", file: MouldOil2 },
  { name: "Balmerol Synth Moldol 32.pdf", file: MouldOil3 },
  { name: "Balmerol Synth Moldol - 80 SS.pdf", file: MouldOil4 },
  { name: "Balmerol Synth Moldol - 50 SS.pdf", file: MouldOil5 },
  { name: "Balmerol Expandol EP 600 (SPL).pdf", file: MouldOil6 },
  { name: "Balmerol Alcast 1000.pdf", file: MouldOil7 }
];

const otherSpecialitiesPDFs = [
  { name: "Balmerol Synth Moldol 80.pdf", file: OtherSpecialities1 },
  { name: "Balmerol Synth Moldol 46.pdf", file: OtherSpecialities2 },
  { name: "Balmerol Synth Moldol 32.pdf", file: OtherSpecialities3 },
  { name: "Balmerol Synth Moldol - 80 SS.pdf", file: OtherSpecialities4 },
  { name: "Balmerol Synth Moldol - 50 SS.pdf", file: OtherSpecialities5 },
  { name: "Balmerol Expandol EP 600 (SPL).pdf", file: OtherSpecialities6 },
  { name: "Balmerol Alcast 1000.pdf", file: OtherSpecialities7 },
  { name: "Balmerol Synthpress 1000.pdf", file: OtherSpecialities8 },
  { name: "Balmerol Synthform PAT.pdf", file: OtherSpecialities9 },
  { name: "Balmerol Protosteel 680.pdf", file: OtherSpecialities10 }
];
const rollingOilPDFs = [
  { name: "Balmerol Steerol 40.pdf", file: RollingOil1 },
  { name: "Balmerol Steerol 22.pdf", file: RollingOil2 },
  { name: "Balmerol Aquaroll 411 (BI).pdf", file: RollingOil3 },
  { name: "Balmerol Aquaroll T 62 (MST-Mod).pdf", file: RollingOil4 },
  { name: "Balmerol Aquaroll T 52 MSR.pdf", file: RollingOil5 },
  { name: "Balmerol Aquaroll HR80.pdf", file: RollingOil6 },
  { name: "Balmerol Aquaroll HI 20 (M).pdf", file: RollingOil7 },
  { name: "Balmerol Aquaroll 632 PDP.pdf", file: RollingOil8 },
  { name: "Balmerol Aquaroll 632 (BI).pdf", file: RollingOil9 },
  { name: "Balmerol Aquaroll 622 (HC).pdf", file: RollingOil10 },
  { name: "Balmerol Aquaroll 432 NSL.pdf", file: RollingOil11 },
  { name: "Balmerol Aquaroll 421 (US).pdf", file: RollingOil12 },
  { name: "Balmerol Aquaroll 631 (PTE).pdf", file: RollingOil13 },
  { name: "Balmerol Aquaroll 421 (BI).pdf", file: RollingOil14 }
];
const quenchOilPDFs = [
  { name: "Balmerol Protoquench Series", file: QuenchOil }
];
const rustPreservativesPDFs = [
  { name: "Balmerol Rustskip 2540.pdf", file: RustPreservatives1 },
  { name: "Balmerol Rustskip 1540 (PC).pdf", file: RustPreservatives2 },
  { name: "Balmerol Rustskip 220 DWF.pdf", file: RustPreservatives3 },
  { name: "Balmerol Rustskip 210 DWF.pdf", file: RustPreservatives4 },
  { name: "Balmerol Rustskip HDX 40.pdf", file: RustPreservatives5 },
  { name: "Balmerol Rustskip GB 320.pdf", file: RustPreservatives6 },
  { name: "Balmerol Rustskip Aquasol MF.pdf", file: RustPreservatives7 },
  { name: "Balmerol Rustskip AP 4040.pdf", file: RustPreservatives8 },
  { name: "Balmerol Rustskip 1040 (SPL).pdf", file: RustPreservatives9 },
  { name: "Balmerol Rustskip 330.pdf", file: RustPreservatives10 },
  { name: "Balmerol Rustskip 100.pdf", file: RustPreservatives11 },
  { name: "Balmerol Anticor 1640.pdf", file: RustPreservatives12 }
];

const turbineOilPDFs = [
  { name: "Balmerol Protomac T Series - ISO VG 68 & Vis 57", file: TurbineOil1 },
  { name: "Balmerol Protomac T Series - ISO VG 32 & 46", file: TurbineOil2 },
  { name: "Balmerol Protomac T (EP) Series", file: TurbineOil3 }
];
const transmissionOilPDFs = [
  { name: "Balmerol Prototrans TO 4 SAE Series.pdf", file: TransmissionOil1 },
  { name: "Balmerol Protomac TC Series.pdf", file: TransmissionOil2 },
  { name: "Balmerol Protomac C4 Series.pdf", file: TransmissionOil3 }
];
const transformerOilPDFs = [
  { name: "Balmerol Transformer Oil.pdf", file: TransformerOil }
];
const threadCompoundsPDFs = [
  { name: "Balmerol TC API MOD.pdf", file: ThreadCompounds1 },
  { name: "Balmerol TC API MOD (M).pdf", file: ThreadCompounds2 },
  { name: "Balmerol Grease TC-Z-50.pdf", file: ThreadCompounds3 },
  { name: "Balmerol Grease TC-CR-60.pdf", file: ThreadCompounds4 },
  { name: "Balmerol Cuprakote TC- 40.pdf", file: ThreadCompounds5 }
];
const marineEngineOilPDFs = [
  { name: "Balmerol Protoform XT.pdf", file: MarineEngineOil1 },
  { name: "Balmerol Protoshakti Series.pdf", file: MarineEngineOil2 }
];
const cylinderOilPDFs = [
  { name: "Balmerol Cuprakote TC- 40.pdf", file: CylinderOil }
];

function Industrial() {
  const [showIndustrial, setShowIndustrial] = useState(false);
  const [showBalmerolCategories, setShowBalmerolCategories] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const balmerolCategories = [
    "Greases",
    "Turbine Oil",
    "Transmission Oil",
    "Transformer Oil",
    "Thread Compounds",
    "Spindle Oil",
    "Rust Preventives",
    "Rolling Oil",
    "Quenching Oil",
    "Other Specialities",
    "Mould Oil",
    "Metal Working Fluid",
    "Marine Engine Oil",
    "Hydraulic Oil",
    "Compressor Oil",
    "Cylinder Oil"
  ];
  const spindleOilPDFs = [
    { name: "spindleoil.pdf", file: SpindleOil }
  ];

  return (
    <div className="industrial-section">
      <div className="industrial-card">
        <h2>Industrial Products</h2>
        <p>
          Explore our comprehensive range of industrial products designed to meet the demands of various industries. 
          From machinery components to specialized tools, we offer reliable and high-performance solutions.
        </p>
      </div>
      <button 
        className="industrial-button" 
        onClick={() => setShowIndustrial(!showIndustrial)}
      >
        Industrial
      </button>

      {showIndustrial && (
        <div className="brand-container">
          <button 
            className="balmerol-button"
            onClick={() => setShowBalmerolCategories(!showBalmerolCategories)}
          >
            Balmerol
          </button>

          {showBalmerolCategories && (
            <div className="categories-container">
              <h3>Balmerol Categories:</h3>
              <div className="category-buttons">
                {balmerolCategories.map((category, index) => (
                  <button
                    key={index}
                    className="category-button"
                    onClick={() => setActiveCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>

              {activeCategory === "Greases" && (
                <div className="pdf-container">
                  <h3 className="section-indicator">You are in the Greases section</h3>
                  <div className="pdf-list">
                    {greasesPDFs.map((pdf, index) => (
                      <a
                        key={index}
                        href={pdf.file}
                        download={pdf.name}
                        className="pdf-link"
                      >
                        Download {pdf.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}

              {activeCategory === "Compressor Oil" && (
                <div className="pdf-container">
                  <h3 className="section-indicator">You are in the Compressor Oil section</h3>
                  <div className="pdf-list">
                    {compressorOilPDFs.map((pdf, index) => (
                      <a
                        key={index}
                        href={pdf.file}
                        download={pdf.name}
                        className="pdf-link"
                      >
                        Download {pdf.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
{activeCategory === "Hydraulic Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Hydraulic Oil section</h3>
    <div className="pdf-list">
      {hydraulicOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Metal Working Fluid" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Metal Working Fluid section</h3>
    <div className="pdf-list">
      {metalWorkingFluidPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Mould Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Mould Oil section</h3>
    <div className="pdf-list">
      {mouldOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Other Specialities" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Other Specialities section</h3>
    <div className="pdf-list">
      {otherSpecialitiesPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Rolling Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Rolling Oil section</h3>
    <div className="pdf-list">
      {rollingOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Quenching Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Quenching Oil section</h3>
    <div className="pdf-list">
      {quenchOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Rust Preventives" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Rust Preventives section</h3>
    <div className="pdf-list">
      {rustPreservativesPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Turbine Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Turbine Oil section</h3>
    <div className="pdf-list">
      {turbineOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Transmission Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Transmission Oil section</h3>
    <div className="pdf-list">
      {transmissionOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Transformer Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Transformer Oil section</h3>
    <div className="pdf-list">
      {transformerOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}

{activeCategory === "Thread Compounds" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Thread Compounds section</h3>
    <div className="pdf-list">
      {threadCompoundsPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Spindle Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Spindle Oil section</h3>
    <div className="pdf-list">
      {spindleOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Marine Engine Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Marine Engine Oil section</h3>
    <div className="pdf-list">
      {marineEngineOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
{activeCategory === "Cylinder Oil" && (
  <div className="pdf-container">
    <h3 className="section-indicator">You are in the Cylinder Oil section</h3>
    <div className="pdf-list">
      {cylinderOilPDFs.map((pdf, index) => (
        <a
          key={index}
          href={pdf.file}
          download={pdf.name}
          className="pdf-link"
        >
          Download {pdf.name}
        </a>
      ))}
    </div>
  </div>
)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Industrial;